import { WorkspaceStatusBadge } from "@/components/checklists/WorkspaceStatusBadge";
import { acknowledgementTwoStatePills } from "@/lib/workspace/status-pill";

interface AcknowledgementStateBadgesProps {
  requestId: string;
  readAt: string | Date | null;
  signedAt: string | Date | null;
}

/**
 * AC15's two states, side by side.
 *
 * Both are always rendered, even when neither has happened: a manager scanning
 * the roster needs to see "not read, not signed" as a positive statement rather
 * than an empty cell they have to interpret.
 */
export function AcknowledgementStateBadges({
  requestId,
  readAt,
  signedAt,
}: AcknowledgementStateBadgesProps) {
  const pills = acknowledgementTwoStatePills({ readAt, signedAt });
  return (
    // Wraps rather than sitting on one line: the cells around it are `shrink-0`,
    // so two un-wrappable pills set a floor on the whole table's width and put a
    // scrollbar under a panel that had room. Stacking them in a narrow column is
    // the better trade.
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
      <span data-testid={`ack-state-read-${requestId}`}>
        <WorkspaceStatusBadge pill={pills.read} />
      </span>
      <span data-testid={`ack-state-signed-${requestId}`}>
        <WorkspaceStatusBadge pill={pills.signed} />
      </span>
    </div>
  );
}
